import React from "react";
import * as Styles from "../styles/BasketList";
import * as BasketConfigCodeStyles from "./styles/BasketConfigCodeStyles";
import useConfigCode from "../../../../../hooks/summary/useConfigCode";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { BnbLabel } from "../../../../../utils/labels";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../../redux/store";
import { MODAL_CONFIG_CODE } from "../../../../../utils/modalConstants";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import ButtonWithIcon from "../../../../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import { trackConfigurationCodeOpen } from "../../../../../utils/tracking";
import ImageFluid from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const BasketConfigCode = (): JSX.Element | null => {
    const { code, showSaving, error, isMasterOrSlave, qrCode } = useConfigCode();
    const step = useBnbSelector((state) => state.navigation.step);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    if (error) return null;

    return (
        <Styles.BasketList>
            {showSaving ? (
                <Type.SmallHeading color="midnight">
                    <BnbLabel label="savingConfig" />
                </Type.SmallHeading>
            ) : (
                <>
                    <BasketConfigCodeStyles.Wrapper>
                        <div>
                            <BasketConfigCodeStyles.Label>
                                <BnbLabel label="yourCode" />
                            </BasketConfigCodeStyles.Label>
                            {!isMasterOrSlave && (
                                <ButtonWithIcon
                                    onClick={() => {
                                        trackConfigurationCodeOpen(step);
                                        dispatch(showModal({ type: MODAL_CONFIG_CODE }));
                                    }}
                                >
                                    <Icon variant="info" data-testid="info-icon" />
                                </ButtonWithIcon>
                            )}
                        </div>
                        <BasketConfigCodeStyles.Wrapper>{code}</BasketConfigCodeStyles.Wrapper>
                    </BasketConfigCodeStyles.Wrapper>

                    {isMasterOrSlave && <ImageFluid src={qrCode} alt="lexus config qr code" data-testid="imageFluid" />}
                </>
            )}
        </Styles.BasketList>
    );
};

export default BasketConfigCode;
